import { LocationSchema } from '@/modules/location/domain/LocationSchema.ts';
import { ContactPersonSchema } from '@/modules/location/domain/ContactPersonSchema.ts';
import { DriverActionSchema } from '@/modules/location/components/DriverActions.tsx';
import { z } from 'zod';
import { LocationAttachmentSchema } from '@/modules/location/domain/Attachment.ts';

export const LocationConfigurationSchema = z.object({
    location: LocationSchema,
    contactPerson: ContactPersonSchema.nullable(),
    driverActions: z.array(DriverActionSchema),
    attachments: z.array(LocationAttachmentSchema),
});

export type LocationConfiguration = z.infer<typeof LocationConfigurationSchema>;
